// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"xO-z","categoryName":"yO-z","categoryNameSearchHeader":"zO-z","categoryContent":"AO-z","bottomAligned":"BO-z","image":"CO-z","imageNoBackground":"DO-z"};